
// src/connects/user-details-modal.js

import { connect } from 'react-redux'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import { translate } from 'react-i18next'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'

export const mapStateToProps = (state, ownProps)=> {
  const isBlock = ownProps.user && find(state.block.users, (user)=> user.user_id == ownProps.user.user_id)
  return {
    favoriteUsers: state.favorite.users,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    isBlock: !!isBlock
  }
}
export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: ()=> dispatch(actions.fetchFavoriteUsers()),
    showUserTimeline: (group_id, user)=> dispatch(actions.openRightSidePage('user_timeline', { group_id: group_id, user_id: user.user_id, user: user })),
    openChatRoom: (props) => {
      if(props.current_user.user_id != props.user.user_id){
        const chatuser = [props.user.user_id]
        dispatch(actions.createChatRoom(chatuser))
      }else{
        dispatch(emitAlertMessage({ message: 'label:ご自身のユーザーでチャットを行うことはできません' }, 'error'))
      }
    },
    isFavorite: (user, props)=> !!find(props.favoriteUsers, (_user)=> _user.user_id == user.user_id),
    toggleFavoriteUser: (user, isFavorite)=> {
      dispatch(actions.updateFavoriteUser(user.user_id, !isFavorite))
      dispatch(emitAlertMessage({ message: !isFavorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: user && user.name }, 'success'))
    },
    willUpdate: (props, nextProps)=> {
      if (nextProps.open && props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }))
        nextProps.onClose && nextProps.onClose()
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-details-modal.js